import type { RouteRecordRaw } from 'vue-router'

export default {
	path: '/',
	children: [
		{
			path: 'guarantee-letters',
			children: [
				{
					path: '',
					name: 'guarantee-letters',
					component: () =>
						import('@/modules/guaranteeLetters/pages/LettersPage.vue'),
				},
				{
					path: 'create',
					name: 'guarantee-letters.create',
					component: () =>
						import('@/modules/guaranteeLetters/pages/LettersPage.vue'),
				},
				{
					path: ':letterId',
					name: 'guarantee-letters.show',
					component: () =>
						import('@/modules/guaranteeLetters/pages/LettersPage.vue'),
				},
			],
		},
		{
			path: 'responsive-letters',
			name: 'responsive-letters',
			redirect: { name: 'guarantee-letters' },
		},
		{
			path: 'responsive-letters/create',
			name: 'responsive-letters.create',
			redirect: { name: 'guarantee-letters.create' },
		},
		{
			path: 'responsive-letters/:folio',
			name: 'responsive-letters.edit',
			redirect: { name: 'guarantee-letters' },
		},
	],
} as RouteRecordRaw
